import { render, staticRenderFns } from "./ProjectContentRealEstate.vue?vue&type=template&id=0d03cae4"
import script from "./ProjectContentRealEstate.vue?vue&type=script&lang=ts"
export * from "./ProjectContentRealEstate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports